import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    containerCol: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerRow: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btn_blog: {
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        borderRadius: 3,
        border: 0,
        color: 'white',
        width: '270px',
        height: '50px',
        fontSize: '12pt',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    },
}));

const Invite = ({ open, onClose }) => {

    const classes = useStyles();

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">
                <Box className={classes.containerRow}>
                    Реферальная система
                </Box>
                <Box className={classes.containerCol} style={{ marginTop: '0.8rem' }}>
                    <Typography align={'center'}> Скоро мы запустим награждения за приглашенных друзей! </Typography>
                    <Button onClick={handleClose} className={classes.btn_blog} size="large" variant="contained" color="primary" style={{ marginTop: '0.9rem' }}>
                        Круто! Жду!
                    </Button>
                </Box>
            </DialogTitle>
        </Dialog>
    );
}

Invite.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default Invite;
